// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2VQTq","upload":"Small_upload__16tRi","imageWrap":"Small_imageWrap__2OIfs","removeBtn":"Small_removeBtn__3eJPP"};